import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddPayeeToBenefitAdjustmentRequestBody } from '@/domains/payments/features/paymentModals/modals/payee/types/requests/AddPayeeToBenefitAdjustmentRequestBody';
import { AddPayeeToPaymentAdjustmentRequestBody } from '@/domains/payments/features/paymentModals/modals/payee/types/requests/AddPayeeToPaymentAdjustmentRequestBody';
import { AddPayeeToPaymentRequestBody } from '@/domains/payments/features/paymentModals/modals/payee/types/requests/AddPayeeToPaymentRequestBody';

const addPayeeSlice = createSlice({
  name: 'addPayeeSlice',
  initialState: {},
  reducers: {
    addPayeeToPayment(_state, _action: PayloadAction<AddPayeeToPaymentRequestBody & { claimId: number }>) {},
    addPayeeToPaymentAdjustment(
      _state,
      _action: PayloadAction<AddPayeeToPaymentAdjustmentRequestBody & { claimId: number }>,
    ) {},
    addPayeeToBenefitAdjustment(
      _state,
      _action: PayloadAction<AddPayeeToBenefitAdjustmentRequestBody & { claimId: number }>,
    ) {},
  },
});

export const { addPayeeToPayment, addPayeeToPaymentAdjustment, addPayeeToBenefitAdjustment } = addPayeeSlice.actions;

export const addPayeeReducer = addPayeeSlice.reducer;
export const addPayeeReducerPath = addPayeeSlice.reducerPath;
